<div [ngClass]="state=='open' ? 'main_content_open' : 'main_content'">
  <p-scrollPanel [style]="{width: '100%', height: '95vh','margin-top':'7px','padding-bottom':'70px'}" #sc>
    <div class="p-d-flex p-jc-between p-ai-center p-pt-3 p-pb-3">
      <div class="page_title">Manage Discount</div>
      <div>
        <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>
      </div>
    </div>
    <p-card>
      <div class="toolbar">
        <div class="p-grid p-ai-center">
          <div class="p-col p-md-6 p-lg-12 p-jc-end d-flex">
            <button pButton pRipple type="button" label="Add Discount"
              class="p-button-raised" style="font-size: 12px;" icon="pi pi-plus"
              (click)="showHideModalDialog('add_discount')"></button>
          </div>
        </div>
      </div>
    </p-card>
    <p-card styleClass="p-mt-3">
      <div class="row form-group">
        <div class="col-sm-12">
          <p-table #dt1 [value]="discounts"
            styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
            [autoLayout]="true" [responsive]="true" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr style="font-size: small;">
                <th>Name</th>
                <th>Description</th>
                <th>Type</th>
                <th>Value</th>
                <th>For</th>
                <th>Industry</th>
                <th>Validity</th>
                <th>Duration</th>
                <th>Activation</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-discount>
              <tr style="font-size: smaller;">
                <td>{{discount.name}}</td>
                <td>{{discount.description}}</td>
                <td>{{discount.discountType}}</td>
                <td>{{getValueLabel(discount)}}</td>
                <td>{{getDiscountForLabel(discount)}}</td>
                <td>
                  {{getIndustryLabel(discount)}}
                  <a *ngIf="(discount.discountIndustries || []).length > 2 && !isAllIndustries(discount)"
                     href="javascript:void(0);"
                     style="color:#007AFF; font-size:0.75rem; white-space:nowrap;"
                     (click)="showIndustryPopup($event, discount, industryOverlay)">
                    +{{(discount.discountIndustries || []).length - 2}} more
                  </a>
                </td>
                <td>{{getValidityLabel(discount)}}</td>
                <td>{{getDurationLabel(discount)}}</td>
                <td>{{getActivationLabel(discount)}}</td>
                <td>
                  <span [ngClass]="discount.status === 'ACTIVE' ? 'badge-active' : 'badge-inactive'">
                    {{discount.status}}
                  </span>
                </td>
                <td class="last_border">
                  <a href="javascript:void(0);" (click)="openEditDialog(discount)">
                    <i class="pi pi-pencil" style="font-size: 0.8rem;color:#007AFF"></i>
                  </a>
                  &nbsp;
                  <a href="javascript:void(0);" (click)="confirmDeleteDialog(discount)">
                    <i class="pi pi-trash" style="font-size: 0.8rem;color:#dc3545"></i>
                  </a>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="11">
                  <div *ngIf="isLoading" class="alignCenter">
                    <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3">
                    </p-progressSpinner>
                  </div>
                  <p-messages *ngIf="discounts?.length == 0 && !isLoading" key="listMsg" class="alignCenter">
                    <ng-template pTemplate>
                      <i class="pi pi-copy" style="font-size: 2rem"></i>
                      <div class="p-ml-2">NO DATA FOUND</div>
                    </ng-template>
                  </p-messages>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-card>
  </p-scrollPanel>
</div>

<!-- ─── ADD DISCOUNT MODAL ─── -->
<p-dialog header="Add Discount" [(visible)]="displayAddModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="true" [maximizable]="true"
  (onHide)="clearFormData()" (onShow)="showDialogMaximized($event, addDialog)" #addDialog>
  <p-messages key="errMsg" [style]="{'font-size': '12px'}"></p-messages>
  <form style="min-width: 65vw;">

    <!-- Row 1: Name + Type -->
    <div class="row">
      <div class="form-group col-md-6">
        <label>Name (Coupon Code)<span class="symbol required"></span></label>
        <input type="text" class="form-control" name="add_name" placeholder="e.g. EARLYADOPTER"
          [(ngModel)]="name" />
      </div>
      <div class="form-group col-md-6">
        <label>Discount Type<span class="symbol required"></span></label>
        <select [(ngModel)]="discountType" class="form-control" name="add_discountType" style="height: 34px;">
          <option *ngFor="let opt of discountTypeOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
    </div>

    <!-- Row 2: Description -->
    <div class="row">
      <div class="form-group col-md-12">
        <label>Description<span class="symbol required"></span></label>
        <textarea class="form-control" name="add_description" placeholder="Enter description"
          rows="2" [(ngModel)]="description"></textarea>
      </div>
    </div>

    <!-- Row 3: Value + For -->
    <div class="row">
      <div class="form-group col-md-6">
        <label>
          Discount Value
          <span style="font-size:11px;color:#6c757d">
            ({{ discountType === 'PERCENT' ? '% e.g. 20' : 'fixed amount or SMS credits' }})
          </span>
          <span class="symbol required"></span>
        </label>
        <input type="number" class="form-control" name="add_discountValue"
          placeholder="Enter value" [(ngModel)]="discountValue" min="0" />
      </div>
      <div class="form-group col-md-6">
        <label>Discount For<span class="symbol required"></span></label>
        <select [(ngModel)]="discountFor" class="form-control" name="add_discountFor" style="height: 34px;">
          <option *ngFor="let opt of discountForOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
    </div>

    <!-- Row 4: Subscription fields (conditional) -->
    <div class="row" *ngIf="discountFor === 'SUBSCRIPTION_WITH_SMS' || discountFor === 'SUBSCRIPTION_WITHOUT_SMS'">
      <div class="form-group col-md-6">
        <label>Subscription Plan</label>
        <select [(ngModel)]="discountSubscriptionType" class="form-control"
          name="add_subType" style="height: 34px;">
          <option *ngFor="let opt of subscriptionTypeOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label>Billing Cycle</label>
        <select [(ngModel)]="discountSubscriptionDuration" class="form-control"
          name="add_subDuration" style="height: 34px;">
          <option *ngFor="let opt of subscriptionDurationOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
    </div>

    <!-- Row 5: Validity -->
    <div class="row">
      <div class="form-group col-md-4">
        <label>Redemption Limit<span class="symbol required"></span></label>
        <select [(ngModel)]="discountValidity" class="form-control" name="add_validity" style="height: 34px;">
          <option *ngFor="let opt of discountValidityOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
      <div class="form-group col-md-4" *ngIf="discountValidity === 'LIMITED'">
        <label>Max Uses<span class="symbol required"></span></label>
        <input type="number" class="form-control" name="add_validityValue"
          placeholder="e.g. 100" [(ngModel)]="discountValidityValue" min="1" />
      </div>
    </div>

    <!-- Row 6: Duration -->
    <div class="row">
      <div class="form-group col-md-4">
        <label>Discount Duration<span class="symbol required"></span></label>
        <select [(ngModel)]="discountDuration" class="form-control" name="add_duration" style="height: 34px;">
          <option *ngFor="let opt of discountDurationOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
      <div class="form-group col-md-4" *ngIf="discountDuration === 'LIMITED'">
        <label>Duration (days)<span class="symbol required"></span></label>
        <input type="number" class="form-control" name="add_durationValue"
          placeholder="e.g. 365" [(ngModel)]="discountDurationValue" min="1" />
      </div>
    </div>

    <!-- Row 7: Discount Activation -->
    <div class="row">
      <div class="form-group col-md-4" style="display: flex; align-items: center;">
        <label style="margin-top: 5px; white-space: nowrap;">Discount Activation<span class="symbol required"></span></label>
        <div style="padding-left: 10px; flex: 1;">
          <select name="add_discountActivation" class="form-control" [(ngModel)]="discountActivation" (ngModelChange)="onActivationChange($event)" style="height: 34px;">
            <option value="immediate">Immediate</option>
            <option value="custom">Custom</option>
          </select>
        </div>
      </div>
      <div class="form-group col-md-4" style="display: flex; align-items: center;" [ngClass]="discountActivation == 'immediate' ? 'disabledbutton' : ''">
        <label style="margin-top: 5px; white-space: nowrap;">Activation Date<span class="symbol required"></span></label>
        <p-calendar name="add_activationDate" [touchUI]="true" #addActivationDate [showIcon]="true"
          [(ngModel)]="discountActivationDate" [readonlyInput]="true" inputId="touchui" [minDate]="minDate"
          placeholder="Enter Start Date" style="padding-left: 5px;">
          <p-footer>
            <button pButton type="button" label="Close" (click)="addActivationDate.hideOverlay()"></button>
          </p-footer>
        </p-calendar>
      </div>
    </div>

    <!-- Row 8: Industry + Status -->
    <div class="row">
      <div class="form-group col-md-6">
        <label>Industry <span style="font-size:11px;color:#6c757d">(leave empty = all industries)</span></label>
        <p-multiSelect
          [(ngModel)]="discountIndustries"
          [options]="businessTypeOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="All Industries"
          [displaySelectedLabel]="true"
          name="add_industry"
          appendTo="body"
          [baseZIndex]="10001"
          [style]="{'width':'100%','font-size':'14px'}">
        </p-multiSelect>
      </div>
      <div class="form-group col-md-6">
        <label>Status<span class="symbol required"></span></label>
        <select [(ngModel)]="status" class="form-control" name="add_status" style="height: 34px;">
          <option *ngFor="let opt of statusOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
    </div>

  </form>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-times" (click)="displayAddModal = false" label="Cancel"
      styleClass="p-button-danger p-button-text"></p-button>
    <p-button icon="pi pi-plus" (click)="addDiscount()" label="Add" [disabled]="disabled"></p-button>
  </ng-template>
  <div *ngIf="isLoading" class="progressLayout">
    <div class="progressContainer">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3"></p-progressSpinner>
    </div>
  </div>
</p-dialog>

<!-- ─── EDIT DISCOUNT MODAL ─── -->
<p-dialog #editDialog header="Edit Discount" [(visible)]="displayEditModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="true" [maximizable]="true"
  (onShow)="showDialogMaximized($event, editDialog)">
  <p-messages key="errMsg" [style]="{'font-size': '12px'}"></p-messages>
  <form style="min-width: 65vw;">

    <!-- Row 1: Name + Type -->
    <div class="row">
      <div class="form-group col-md-6">
        <label>Name (Coupon Code)<span class="symbol required"></span></label>
        <input type="text" class="form-control" name="edit_name" placeholder="e.g. EARLYADOPTER"
          [(ngModel)]="name" />
      </div>
      <div class="form-group col-md-6">
        <label>Discount Type<span class="symbol required"></span></label>
        <select [(ngModel)]="discountType" class="form-control" name="edit_discountType" style="height: 34px;">
          <option *ngFor="let opt of discountTypeOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
    </div>

    <!-- Row 2: Description -->
    <div class="row">
      <div class="form-group col-md-12">
        <label>Description<span class="symbol required"></span></label>
        <textarea class="form-control" name="edit_description" placeholder="Enter description"
          rows="2" [(ngModel)]="description"></textarea>
      </div>
    </div>

    <!-- Row 3: Value + For -->
    <div class="row">
      <div class="form-group col-md-6">
        <label>
          Discount Value
          <span style="font-size:11px;color:#6c757d">
            ({{ discountType === 'PERCENT' ? '% e.g. 20' : 'fixed amount or SMS credits' }})
          </span>
          <span class="symbol required"></span>
        </label>
        <input type="number" class="form-control" name="edit_discountValue"
          placeholder="Enter value" [(ngModel)]="discountValue" min="0" />
      </div>
      <div class="form-group col-md-6">
        <label>Discount For<span class="symbol required"></span></label>
        <select [(ngModel)]="discountFor" class="form-control" name="edit_discountFor" style="height: 34px;">
          <option *ngFor="let opt of discountForOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
    </div>

    <!-- Row 4: Subscription fields (conditional) -->
    <div class="row" *ngIf="discountFor === 'SUBSCRIPTION_WITH_SMS' || discountFor === 'SUBSCRIPTION_WITHOUT_SMS'">
      <div class="form-group col-md-6">
        <label>Subscription Plan</label>
        <select [(ngModel)]="discountSubscriptionType" class="form-control"
          name="edit_subType" style="height: 34px;">
          <option *ngFor="let opt of subscriptionTypeOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label>Billing Cycle</label>
        <select [(ngModel)]="discountSubscriptionDuration" class="form-control"
          name="edit_subDuration" style="height: 34px;">
          <option *ngFor="let opt of subscriptionDurationOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
    </div>

    <!-- Row 5: Validity -->
    <div class="row">
      <div class="form-group col-md-4">
        <label>Redemption Limit<span class="symbol required"></span></label>
        <select [(ngModel)]="discountValidity" class="form-control" name="edit_validity" style="height: 34px;">
          <option *ngFor="let opt of discountValidityOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
      <div class="form-group col-md-4" *ngIf="discountValidity === 'LIMITED'">
        <label>Max Uses<span class="symbol required"></span></label>
        <input type="number" class="form-control" name="edit_validityValue"
          placeholder="e.g. 100" [(ngModel)]="discountValidityValue" min="1" />
      </div>
    </div>

    <!-- Row 6: Duration -->
    <div class="row">
      <div class="form-group col-md-4">
        <label>Discount Duration<span class="symbol required"></span></label>
        <select [(ngModel)]="discountDuration" class="form-control" name="edit_duration" style="height: 34px;">
          <option *ngFor="let opt of discountDurationOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
      <div class="form-group col-md-4" *ngIf="discountDuration === 'LIMITED'">
        <label>Duration (days)<span class="symbol required"></span></label>
        <input type="number" class="form-control" name="edit_durationValue"
          placeholder="e.g. 365" [(ngModel)]="discountDurationValue" min="1" />
      </div>
    </div>

    <!-- Row 7: Discount Activation -->
    <div class="row">
      <div class="form-group col-md-4" style="display: flex; align-items: center;">
        <label style="margin-top: 5px; white-space: nowrap;">Discount Activation<span class="symbol required"></span></label>
        <div style="padding-left: 10px; flex: 1;">
          <select name="edit_discountActivation" class="form-control" [(ngModel)]="discountActivation" (ngModelChange)="onActivationChange($event)" style="height: 34px;">
            <option value="immediate">Immediate</option>
            <option value="custom">Custom</option>
          </select>
        </div>
      </div>
      <div class="form-group col-md-4" style="display: flex; align-items: center;" [ngClass]="discountActivation == 'immediate' ? 'disabledbutton' : ''">
        <label style="margin-top: 5px; white-space: nowrap;">Activation Date<span class="symbol required"></span></label>
        <p-calendar name="edit_activationDate" [touchUI]="true" #editActivationDate [showIcon]="true"
          [(ngModel)]="discountActivationDate" [readonlyInput]="true" inputId="touchui" [minDate]="minDate"
          placeholder="Enter Start Date" style="padding-left: 5px;">
          <p-footer>
            <button pButton type="button" label="Close" (click)="editActivationDate.hideOverlay()"></button>
          </p-footer>
        </p-calendar>
      </div>
    </div>

    <!-- Row 8: Industry + Status -->
    <div class="row">
      <div class="form-group col-md-6">
        <label>Industry <span style="font-size:11px;color:#6c757d">(leave empty = all industries)</span></label>
        <p-multiSelect
          [(ngModel)]="discountIndustries"
          [options]="businessTypeOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="All Industries"
          [displaySelectedLabel]="true"
          name="edit_industry"
          appendTo="body"
          [baseZIndex]="10001"
          [style]="{'width':'100%','font-size':'14px'}">
        </p-multiSelect>
      </div>
      <div class="form-group col-md-6">
        <label>Status<span class="symbol required"></span></label>
        <select [(ngModel)]="status" class="form-control" name="edit_status" style="height: 34px;">
          <option *ngFor="let opt of statusOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
    </div>

  </form>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-times" (click)="displayEditModal = false" label="Cancel"
      styleClass="p-button-danger p-button-text"></p-button>
    <p-button icon="pi pi-save" (click)="editDiscount()" label="Save" [disabled]="disabled"></p-button>
  </ng-template>
  <div *ngIf="isLoading" class="progressLayout">
    <div class="progressContainer">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3"></p-progressSpinner>
    </div>
  </div>
</p-dialog>

<!-- ─── DELETE CONFIRMATION ─── -->
<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" [style]="{width:'45vw'}">
</p-confirmDialog>

<!-- ─── INDUSTRY OVERLAY PANEL ─── -->
<p-overlayPanel #industryOverlay appendTo="body" [showCloseIcon]="false">
  <ng-template pTemplate>
    <ul style="margin:0; padding:0 0 0 16px; max-height:180px; overflow-y:auto; min-width:120px; font-size:12px;">
      <li *ngFor="let ind of activeIndustries" style="padding:2px 0;">{{ind}}</li>
    </ul>
  </ng-template>
</p-overlayPanel>
